import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';

import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';

const useStyles = makeStyles(theme => ({
  cta: {
    background: theme.palette.bg.main,
    color: theme.palette.primary.main,
    fontFamily: ['NiceGroteskBQ-BoldExt'].join(','),
    fontSize: '8px',
    height: props => (props.shrink ? '32px' : '48px'),
    letterSpacing: '0.16em !important',
    width: '160px',
    '&:hover': {
      background: theme.palette.bg.main,
      opacity: '0.9'
    }
  },
  root: {
    background: theme.palette.primary.main,
    padding: '72px 0px 0px 0px',
    [theme.breakpoints.down('md')]: {
      padding: '36px 0px 0px 0px'
    }
  }
}));

export default function PricingCallToAction(props) {
  const classes = useStyles();

  return (
    <Grid classes={{ root: classes.root }} justifyContent="center" container>
      <Button
        variant="contained"
        classes={{ root: classes.cta }}
        onClick={() => props.history.push('/signup')}
      >
        Start Your Order
      </Button>
    </Grid>
  );
}

PricingCallToAction.propTypes = {
  history: PropTypes.object.isRequired
};
